import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson14: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson13"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch text-center flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Self Control</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson15"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[9.44rem] text-justify text-gainsboro-100 font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[9.44rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>What Are Thoughts?</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              Thoughts are the muscles of the mind. If your thought patterns
              have been in the wrong position for a long time, it will take time
              and training to make them flexible again and be able to redirect
              them.
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              Creating thought patterns is often an unconscious process; you
              don't realize it. Where do your beliefs come from today? How did
              they get into you? You need to understand how that conditioning
              formed and how those thought patterns shape your life. Only then
              can you have control over your existence.
            </p>
          </div>
          <img
            className="relative w-[29.19rem] h-[26.13rem] object-cover"
            alt=""
            src="/27@2x.png"
          />
        </div>
        <p className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <b className="m-0 text-[1.88rem]">Body vs Mind:</b>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            To fully understand this section on thought patterns and mastery of
            your mindset, it is important to understand the distinction between
            body and mind. According to many scientists, giving our thoughts is
            a product of the brain, an invention of ourselves. Renowned brain
            researcher and professor of neurobiology Dick Swaab says in We are
            our brain, "I have never heard a good argument against my simple
            conclusion that they give is the result of our hundred billion brain
            cells.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Since this statement comes from an expert, this is a very possible
            proposition. However, Michael Pilarczyk tells it differently in
            'Master your mindset': 'From my own experience, I have the view that
            the mind is an energy field that resides in every cell of the body,
            including the brain, and that this energy field also moves outside
            our physical body. Your body is just a small part, an instrument of
            your vast mind that consists of your limited consciousness and the
            infinite subconscious. You can find this view in many ancient
            philosophies and spiritual ways of thinking. I have never heard an
            argument that can refute this view.'
          </p>
          <p className="m-0">&nbsp;</p>
        </p>
        <p className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <b className="m-0 text-[1.88rem]">
            Consciousness vs Subconsciousness:
          </b>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">{`Through your senses, you receive information. When that information is processed by your brain, you are aware of it. This is your consciousness, the part that thinks and reasons. This part also contains your free will, the power to choose. Consciousness can accept or reject any idea or thought. `}</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The subconscious cannot. it, like that hard disk, allows all
            information in and cannot distinguish between good and bad, reality
            or fantasy. It doesn't judge, it is. All those thoughts, emotions,
            images, and experiences leave traces in your subconscious. Negative
            thoughts are weeds in your mind. When you don't weed it out
            immediately, it creates proliferation that deprives you of your
            view.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">{`You do this by consciously choosing what you pay attention to. The thoughts you pay the most attention to will influence your daily life. If you get stuck in negative, angry, insecure, and anxious thoughts, you will not make progress. Positive, inspiring, happy, and successful thoughts, on the other hand, are more likely to get rewarded with happiness, inner peace, freedom, money, and a beautiful life. `}</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            When you repeat a thought over and over again, you begin to believe
            in that thought. Speaking that thought out loud reinforces the way
            you program yourself. This predominant thought then becomes an
            automatism, a habit, regardless of whether that thought is good or
            bad for you.
          </p>
          <p className="m-0">&nbsp;</p>
        </p>
        <p className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <b className="m-0 text-[1.88rem]">
            Changing Your Thought Patterns:
          </b>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">{`The subconscious mind is controlled by the software you put in it and by software received and stored unconsciously. It expresses itself in how you feel, how you react, and what you undertake. If you create predominantly negative thoughts, they immediately influence your behaviour and emotions and ultimately the results you achieve. `}</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Do you put healthy fruits and vegetables in the blender or alcohol,
            drugs, and antidepressants? Will it be a healthy smoothie or a toxic
            cocktail? the result depends on the recipe and the ingredients. It
            works the same way with thoughts. The learning process of being
            positive (not just thinking) starts with the recognition of
            destructive thoughts. Once you are aware that your negative thoughts
            lead to negative emotions, e can replace them with positive
            thoughts.
          </p>
          <p className="m-0">&nbsp;</p>
        </p>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson15"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson14;
